import { render, staticRenderFns } from "./_base.vue?vue&type=template&id=9052860a"
import script from "./_base.js?vue&type=script&lang=js&external"
export * from "./_base.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports